import React, { useState } from 'react'
import { API, Card, Help, Date as FormDate, Submit } from '@enkla-gui'
import { date, notify } from '@/_helpers'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

export default function ReturnModal({ quittance, onClose, onSuccess }) {
		const { control, handleSubmit } = useForm({
		defaultValues: { return_date: date.now() }
	})
	const [sending, setSending] = useState(false)
	const [error, setError] = useState(null)

	const onSubmit = data => {
		const returnDate = data.return_date
		if (!returnDate) {
			setError('Återlämningsdatum är obligatoriskt')
			return
		}
		setSending(true)
		setError(null)
		API.patch('api/quittance', { id: quittance.id, return_date: returnDate })
			.then(() => {
				notify.toast('Kvittens återlämnad', 'success')
				onSuccess()
			})
			.catch(([err, res]) => {
				const msg = res?.data ? Object.values(res.data).flat().join(', ') : (res?.message || 'Kunde inte markera som återlämnad')
				setError(msg)
				notify.toast(msg, 'error')
				setSending(false)
			})
	}

	return (
		<Modal isOpen={true} onRequestClose={onClose} className='no-padding'>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Card
					collapsed={null}
					title='Bekräfta återlämning'
					icon='fas fa-check-circle'
					buttons={{
						header: [{ callback: onClose, text: 'Avbryt', bg: 'light' }],
						footer: [<Submit onSubmit={handleSubmit(onSubmit)} text='Bekräfta' sending={sending} disabled={sending} />]
					}}
				>
					<Help type='info' icon='fas fa-info-circle'>
						<strong>{quittance.name}</strong><br />
						Antal: {quittance.quantity}<br />
						Typ: {quittance.type}<br />
						{quittance.marking && <>Märkning: {quittance.marking}<br /></>}
						Utlämnad: {date.short(quittance.handout_date)}
					</Help>

					<div class='row'>
						<FormDate
							controls={{ control }}
							name='return_date'
							label='Återlämningsdatum'
							placeholder='Datum'
							cols='col-12 col-md-6'
						/>
					</div>
					{error && (
						<div class='form-inline-error mt-2'>
							<i class='fa fa-fw fa-exclamation-triangle' /> {error}
						</div>
					)}
					<Help type='warning' icon='fas fa-exclamation-triangle'>
						Markeras som återlämnad och flyttas till historik.
					</Help>
				</Card>
			</form>
		</Modal>
	)
}
